import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var AddPatientRes;
export const AddPatientTodo = createAsyncThunk('adminAddPatient', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/patient',
            data: {
              
                "company_id": localStorage.getItem('companyId'),
                "name": data.name,
                "phone": data.phone,
                "email": data.email,
                "age": data.age,
                "gender": data.gender,
                "status": data?.status,
                "added_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddPatientRes = res.data

    } catch (error) {
        return AddPatientRes = error.response.data
    }
})